module.exports = __webpack_public_path__ + "static/media/instagram.167c9326.svg";